module.exports = __webpack_public_path__ + "static/media/Mulish-Black.86494e7f.svg";